<template>
  <a-row class="j-select-biz-component-box" type="flex" :gutter="8">
    <a-col class="left" :class="{'full': !buttons}">
      <slot name="left">
        <a-select
          mode="multiple"
          :placeholder="$store.getters.language['common.pleaseChoose']"
          v-model="selectValue"
          :options="selectOptions"
          allowClear
          :disabled="disabled"
          :open="selectOpen"
          style="width: 100%;"
          @dropdownVisibleChange="handleDropdownVisibleChange"
          @click.native="visible=(buttons || disabled ?visible:true)"
        />
      </slot>
    </a-col>

    <a-col class="right">
      <a-button v-if="buttons" type="primary" icon="search"  :disabled="disabled" @click="visible=true;updateData(true)">{{this.$store.getters.language['common.selectButton']}}</a-button>
      <a-button v-if="isSort" style="margin-top: 5px;" type="primary" icon="swap"  :disabled="disabled" @click="sortVisible=true;"> {{ this.$store.getters.language['common.sort'] }} </a-button>
    </a-col>

    <j-select-biz-component-modal
      ref="selectBizComponentRef"
      v-model="selectValue"
      :visible.sync="visible"
      :rowKey="rowKey"
      :paginationFlag="paginationFlag"
      v-bind="modalProps"
      @options="handleOptions"
      :setModelUpdate="updateData"
      @input="handleChange"
    />

   <j-modal
      :title="this.$store.getters.language['common.sort']"
      :width="450"
      :visible="sortVisible"
      switchFullscreen
      @change="sortVisible = false"
      @ok="handleSortClick"
    >
      <j-select-sort ref="sortModal" :sortItem="sortItem" @handleSortOk="handleSortOk" />
    </j-modal>
  </a-row>
</template>

<script>
  import JSelectBizComponentModal from './JSelectBizComponentModal'
  import JSelectSort from './JSelectSort'

  export default {
    name: 'JSelectBizComponent',
    components: { JSelectBizComponentModal, JSelectSort },
    props: {
      value: {
        type: String,
        default: ''
      },
      /** 是否返回 id，默认 false，返回 code */
      returnId: {
        type: Boolean,
        default: false
      },
      placeholder: {
        type: String,
        default: '请选择'
      },
      disabled: {
        type: Boolean,
        default: false
      },
      // 是否支持多选，默认 true
      multiple: {
        type: Boolean,
        default: true
      },
      // 是否显示按钮，默认 true
      buttons: {
        type: Boolean,
        default: true
      },
      // 显示的 Key
      displayKey: {
        type: String,
        default: null
      },
      displayName:{
        type: String,
        default: null
      },
      // 返回的 key
      returnKeys: {
        type: Array,
        default: () => ['id', 'id']
      },
      // 选择按钮文字
      selectButtonText: {
        type: String,
        default: '选择'
      },
      option: {
        type: Array,
        default: ()=>[]
      },
      objectId: {
        type: String,
        default: ''
      },
      isFix: {
        type: Boolean,
        default: false
      },
      rowKey: {
        type: String,
        default: 'id'
      },
      paginationFlag: {
        type: Boolean,
        default: true
      },

      // 是否显示排序按钮，默认 fales
      isSort: {
        type: Boolean,
        default: false
      },
      // 需要排序的數據
      sortItem: {
        type: Object,
      },
    },
    computed:{
      language() {
        return this.$store.getters.language
      },
    },
    data() {
      return {
        selectValue: [],
        showValue: [],
        selectOptions: [],
        dataSourceMap: {},
        visible: false,
        dataVisible:true,
        selectOpen: false,
        sortVisible: false,
      }
    },
    created() {
    },
    computed: {
      valueKey() {
        return this.returnId ? this.returnKeys[0] : this.returnKeys[1]
      },
      modalProps() {
        return Object.assign({
          valueKey: this.valueKey,
          multiple: this.multiple,
          returnKeys: this.returnKeys,
          displayKey: this.displayKey || this.valueKey
        }, this.$attrs)
      },
    },
    watch: {
      value: {
        immediate: true,
        handler(val) {
          if (val) {
            this.selectValue = val.split(',')
          } else {
            this.selectValue = []
          }
        }
      },
      selectValue: {
        deep: true,
        handler(val) {
          let rows = val.map(key => this.dataSourceMap[key])
          let data = val.join(',')
          if (data !== this.value) {
            this.$emit('select', rows)
            this.$emit('input', data)
            this.$emit('change', data)
          }
        }
      }
    },
    methods: {
      handleChange(val, display) {
        this.showValue = display
      },
      handleOptions(options, dataSourceMap, allOptions) {
      /*  console.log("sleect option----------------:",options)

        console.log("this.selectOptions----------------:",this.selectOptions)*/
        //this.option为父组件传入的值，如果length为0就表明父组件没有传值。继续用回原来的子组件回调的值
        if(this.option.length>0){
          this.selectOptions=this.option;
        } else{
          this.selectOptions=allOptions && allOptions.length > 0 ? allOptions : options;
        }
        this.dataSourceMap = dataSourceMap
      },
      handleDropdownVisibleChange() {
        // 解决antdv自己的bug —— open 设置为 false 了，点击后还是添加了 open 样式，导致点击事件失效
        // this.selectOpen = true
        this.$nextTick(() => {
          this.selectOpen = false
        })
      },
      updateData(visible){
        this.dataVisible=visible;

        if (this.isFix) {
          //施工：修复厂商人员角色分配弹框会保留上一次操作的过滤结果
          console.log("updateData : ",this.objectId)
          this.$refs.selectBizComponentRef.fixUpdateData(this.objectId)
        }
      },

      handleSortClick() {
        this.$refs.sortModal.handleOk()
      },

      handleSortOk(id, userCodes, userNames) {
        this.sortVisible = false
        this.$emit('handleSortOk', id, userCodes, userNames)
      },  
    }
  }
</script>

<style lang="less" scoped>
  .j-select-biz-component-box {

    @width: 82px;

    .left {
      width: calc(100% - @width - 8px);
    }

    .right {
      width: @width;
    }

    .full {
      width: 100%;
    }

    /deep/ .ant-select-search__field {
      display: none !important;
    }
  }
</style>